import LoadData from "../save-load/LoadData";

function LocationCheck(api, value, setting) {
  const locationData = LoadData("Location");

  if (api === "SMHI") {
    if (!setting) {
      return true;
    } else {
      const region = locationData.region_name;

      const subgroups = {
        "Stockholm County": [
          "Stockholms län,Roslagskusten",
          "Stockholms län utom Roslagskusten",
        ],

        "Västerbotten County": [
          "Västerbottens län,södra Lapplandsfjällen",
          "Västerbottens län inland",
          "Västerbottens län kustland",
        ],

        "Norrbotten County": [
          "Norrbottens län,norra Lapplandsfjällen",
          "Norrbottens län inland",
          "Norrbottens län kustland",
        ],
        "Uppsala County": [],
        "Södermanland County": [],
        "Östergötland County": [],
        "Jönköping County": [],
        "Kronoberg County": [],
        "Kalmar County": [],
        "Gotland County": [],
        "Blekinge County": [],
        "Skåne County": [],
        "Halland County": [],
        "Västra Götaland County": [],
        "Värmland County": [],
        "Örebro County": [],
        "Västmanland County": [],
        "Dalarna County": [],
        "Gävleborg County": [],
        "Västernorrland County": [],
        "Jämtland County": [],
      };

      return subgroups[region].includes(value);
    }
  }

  if (api === "BrottsplatsKartan") {
    if (!setting) return "";
    else {
      const region = locationData.region_name;

      const subgroups = {
        "Stockholm County": "Stockholms län",
        "Västerbotten County": "Västerbottens län",
        "Norrbotten County": "Norrbottens län",
        "Uppsala County": "Uppsala län",
        "Södermanland County": "Södermanlands län",
        "Östergötland County": "Östergötlands län",
        "Jönköping County": "Jönköpings län",
        "Kronoberg County": "Kronobergs län",
        "Kalmar County": "Kalmar län",
        "Gotland County": "Gotlands län",
        "Blekinge County": "Blekinge län",
        "Skåne County": "Skåne län",
        "Halland County": "Hallands län",
        "Västra Götaland County": "Västra Götalands län",
        "Värmland County": "Värmlands län",
        "Örebro County": "Örebro län",
        "Västmanland County": "Västmanlands län",
        "Dalarna County": "Dalarnas län",
        "Gävleborg County": "Gävleborgs län",
        "Västernorrland County": "Västernorrlands län",
        "Jämtland County": "Jämtslands län",
      };

      console.log(subgroups[region]);

      return subgroups[region];
    }
  }
}

export default LocationCheck;
